module.exports = __webpack_public_path__ + "img/clock-icon.e1e33c02.svg";